import { LangUri } from '@catawiki/runtime-toolkit';
import { HELP_COOKIES_PATH } from '../constants';
const GENERAL_TERMS_PAGE_REGEXP = /\/pages\/p\/terms-of-use(?:$|\/.*)/;
const SELLER_TERMS_PAGE_REGEXP = /\/pages\/p\/seller-terms(?:$|\/.*)/;
const BUYER_TERMS_PAGE_REGEXP = /\/pages\/p\/buyer-terms(?:$|\/.*)/;
const GLOSSARY_PAGE_REGEXP = /\/pages\/p\/glossary(?:$|\/.*)/;
const TERMS_PAGE_REGEXP = new RegExp([
    GENERAL_TERMS_PAGE_REGEXP.source,
    SELLER_TERMS_PAGE_REGEXP.source,
    BUYER_TERMS_PAGE_REGEXP.source,
    GLOSSARY_PAGE_REGEXP.source,
].join('|'));
const HELP_SECTION_REGEXP = /\/help(?:$|\/.*)/;
export const checkPathnameInPage = (pathname, pageOrRegExp, defaultLangPaths) => {
    if (!pageOrRegExp) {
        return false;
    }
    const split = pathname.split(pageOrRegExp);
    // ['/hu', ''] - if matched
    const [possibleSlashPlusLang, emptyIfMatched] = split;
    // if HELP_SECTION_PATH not found in pathname then early exist with false
    // split.length < 2 if not found, split.length > 2 if found more than one match
    if (split.length !== 2 || emptyIfMatched.length > 0) {
        return false;
    }
    // for pathname '/help/cookies', possibleSlashPlusLang === ''
    // for pathname '/<lang>/help/cookies', possibleSlashPlusLang = '/<lang>'
    // remove slash
    const possibleLang = possibleSlashPlusLang.slice(1);
    return !possibleLang || defaultLangPaths.includes(possibleLang);
};
export const checkPageInHelpSection = (pathname, defaultLangPaths) => checkPathnameInPage(pathname, HELP_SECTION_REGEXP, defaultLangPaths);
export const checkPageIsTermsPage = (pathname, defaultLangPaths) => checkPathnameInPage(pathname, TERMS_PAGE_REGEXP, defaultLangPaths);
export const isHelpCookiesPage = (pathname) => checkPathnameInPage(pathname, HELP_COOKIES_PATH, LangUri.defaultLangPaths);
//# sourceMappingURL=pages.js.map